import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-fluid p-component p-formgrid p-grid p-input-filled" }
const _hoisted_2 = { class: "p-field p-col-12" }
const _hoisted_3 = { for: "userIdTo" }
const _hoisted_4 = {
  key: 0,
  class: "p-error"
}
const _hoisted_5 = { class: "p-field p-col-12" }
const _hoisted_6 = { for: "userIdFrom" }
const _hoisted_7 = {
  key: 0,
  class: "p-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('Squeeze.UserManagement.UserToDescription')) + " *", 1),
      _createVNode(_component_Dropdown, {
        id: "userIdTo",
        modelValue: _ctx.value.userIdTo,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value.userIdTo) = $event)),
        options: _ctx.usersTo,
        loading: _ctx.loading,
        optionValue: "id",
        optionLabel: _ctx.getUsersFullName,
        filter: true,
        autoFilterFocus: true,
        showClear: true,
        disabled: true,
        onShow: _ctx.showDropdownOverlay
      }, null, 8, ["modelValue", "options", "loading", "optionLabel", "onShow"]),
      (_ctx.v$.userIdTo.$invalid && _ctx.showErrorMessage)
        ? (_openBlock(), _createElementBlock("small", _hoisted_4, _toDisplayString(_ctx.$t('Forms.Val.MissingRequired', { field: _ctx.$t('Squeeze.UserManagement.UserToDescription')})), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('Squeeze.UserManagement.UserFromDescription')) + " *", 1),
      _createVNode(_component_Dropdown, {
        id: "userIdFrom",
        modelValue: _ctx.value.userIdFrom,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.value.userIdFrom) = $event)),
        options: _ctx.usersFrom,
        loading: _ctx.loading,
        optionValue: "id",
        optionLabel: _ctx.getUsersFullName,
        filter: true,
        autoFilterFocus: true,
        showClear: true,
        onChange: _ctx.update,
        onShow: _ctx.showDropdownOverlay
      }, null, 8, ["modelValue", "options", "loading", "optionLabel", "onChange", "onShow"]),
      (_ctx.v$.userIdFrom.$invalid && _ctx.showErrorMessage)
        ? (_openBlock(), _createElementBlock("small", _hoisted_7, _toDisplayString(_ctx.$t('Forms.Val.MissingRequired', { field: _ctx.$t('Squeeze.UserManagement.UserFromDescription')})), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}